<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon: cart; ratio:1.2"></span>
            Bestellungen
          </h1>
        </div>
        <div v-if="meta && meta.pagination.total_pages > 1">
          <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div v-if="sales.length && !loading">
      <sale-list-admin :sales="sales" @removed="getSales()"></sale-list-admin>
    </div>
    <div v-if="meta && meta.pagination.total_pages > 1" class="uk-margin-small">
      <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
    </div>
  </div>
</template>
<script>
import SaleService from '@/services/sale.service'
import SaleListAdmin from '@/components/SaleListAdmin'
import Pagination from '@/components/Pagination'
export default {
  data() {
    return {
      sales: [],
      meta: null,
      loading: true
    }
  },
  components: {
    SaleListAdmin,
    Pagination
  },
  mounted() {
    this.getSales()
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.getSales(query)
      },
      deep: true
    }
  },
  methods: {
    async getSales(params = this.$route.query) {
      const sales = await SaleService.getAll({...params})
      this.sales = sales.data.sales
      this.meta = sales.data.meta
      this.loading = false
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onSearch(params) {
      this.addParamsToLocation({ ...params })
      this.getSales(params)
    },
    onPaginationSwitch(page) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const currentParams = Object.fromEntries(urlSearchParams.entries());
      const params = Object.assign({}, {...currentParams}, { page })
      this.onSearch(params)
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    }
  }
}
</script>
